export default __webpack_public_path__ + "static/media/vehicle-6.ce0a074d.png";